import Footer from "../components/Footer";
import { useState, useEffect } from "react";
import axios from "axios";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import swal from "sweetalert";
import KeyboardArrowLeftOutlinedIcon from "@mui/icons-material/KeyboardArrowLeftOutlined";
import AnimatedPage from "../components/AnimatedPage";

function TransferGame() {
    const [profile, setProfile] = useState(JSON.parse(localStorage.getItem("profile")));
    const [newMoney, setNewMoney] = useState("");
    const [balance, setBalance] = useState(0);
    const [sanh, setSanh] = useState("");
    const [type, setType] = useState(null);
    const [load, setLoad] = useState(false);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleBackClick = () => {
        navigate(-1);
    };

    axios.interceptors.request.use(
        (config) => {
            const token = localStorage.getItem("user");
            if (token) {
                config.headers["Authorization"] = `Bearer ${token}`;
            }
            return config;
        },
        (error) => {
            return Promise.reject(error);
        }
    );

    const { register, handleSubmit, setValue } = useForm();

    useEffect(() => {
        axios.get(`${process.env.REACT_APP_API_URL}/auth/getUser`, {}).then((res) => {
            if (profile != res.data.data) {
                setProfile(res.data.data);
                localStorage.setItem("profile", JSON.stringify(res.data.data));
            }
        });
    }, []);

    useEffect(() => {
        axios.post(`${process.env.REACT_APP_API_URL}/casino/create`, {});
    }, [profile]);

    const onSubmit = (data) => {
        if (load === false) {
            if (!sanh) {
                swal("Thông báo", "Vui lòng chọn sảnh", "warning");
                return;
            }
            const formData = {
                product_type: sanh,
                type: type,
                money: Number(data.money.replaceAll(".", "").replaceAll(",", ""))
            };
            if (!type) {
                swal("Chú ý", "Vui lòng chọn chuyển tiền vào hoặc chuyển tiền ra", "warning");
                return;
            }
            setLoad(true);
            axios
                .post(`${process.env.REACT_APP_API_URL}/casino/transfer`, formData)
                .then((res) => {
                    if (type == "2") {
                        swal("Thành công", `Chuyển quỹ ra khỏi sảnh thành công!`, "success").then(() => window.location.reload());
                    } else {
                        swal("Thành công", `Chuyển quỹ vào sảnh thành công!`, "success").then(() => window.location.reload());
                    }
                    axios
                        .get(`${process.env.REACT_APP_API_URL}/auth/getUser`, {})
                        .then((res) => {
                            setProfile(res.data.data);
                        })
                        .catch((err) => localStorage.removeItem("user"));
                    setLoad(false);
                })
                .catch((err) => {
                    swal("Thất bại", err.response.data.message != "internal server error" ? err.response.data.message : "Đã xảy ra lỗi", "error");
                    setLoad(false);
                });
        }
    };

    const handleChange = (e) => {
        setLoading(true);
        setSanh(e.target.value);
        setNewMoney(""); 
        setValue("money", ""); // Reset lại ô input khi đổi sảnh

        axios
            .post(`${process.env.REACT_APP_API_URL}/casino/getbalance`, { product_type: e.target.value })
            .then((res) => {
                setBalance(res.data.data.balance);
                setLoading(false);
            })
            .catch((err) => {
                swal("Đã xảy ra lỗi", "Vui lòng đăng xuất và đăng nhập lại", "error");
                setLoading(false);
            });
    };

    const selectAll = (e) => {
        if (type == 1) {
            if (profile?.money > 0) {
                const max = Math.floor(profile.money).toLocaleString("vi-VN");
                setNewMoney(max);
                setValue("money", max); // Set giá trị cho form hook
            }
        } else if (type == 2) {
            if (balance > 0) {
                const max = Math.floor(balance).toLocaleString("vi-VN");
                setNewMoney(max);
                setValue("money", max); // Set giá trị cho form hook
            }
        } else {
            swal("Chú ý", "Vui lòng chọn chuyển tiền vào hoặc chuyển tiền ra", "warning");
        }
    };

    return (
        <div style={{ display: "flex", flexDirection: "column", height: "100vh", background: "#f4f6f8", overflow: "hidden" }}>
            {/* GẮN CSS TÙY CHỈNH CHO GIAO DIỆN MỚI */}
            <style dangerouslySetInnerHTML={{__html: `
                * { font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif; box-sizing: border-box; }
                body { background-color: #f4f6f8; margin: 0; padding: 0; color: #333; }
                
                .t-app-main {
                    position: fixed; top: 0; bottom: 60px; left: 0; right: 0; 
                    margin: 0 auto; max-width: 540px; background: #f4f6f8; 
                    display: flex; flex-direction: column; overflow-y: auto; overflow-x: hidden;
                    z-index: 10;
                }
                .t-app-main::-webkit-scrollbar { display: none; }
                .t-app-main { -ms-overflow-style: none; scrollbar-width: none; }

                .t-header {
                    display: flex; align-items: center; justify-content: space-between;
                    height: 50px; padding: 0 15px; border-bottom: 1px solid #f0f0f0; background: #fff;
                    position: sticky; top: 0; z-index: 50;
                }
                .t-header-back { cursor: pointer; display: flex; align-items: center; justify-content: center; }
                .t-header-title { font-size: 16px; font-weight: 700; color: #333; flex: 1; text-align: center; margin-right: -24px;}

                .t-bal-wrap {
                    background: #2ba1d8; color: #fff; padding: 25px 20px; text-align: center;
                    margin-bottom: 20px; box-shadow: 0 4px 10px rgba(43, 161, 216, 0.2);
                }
                .t-bal-title { font-size: 13px; opacity: 0.9; margin-bottom: 5px; text-transform: uppercase; }
                .t-bal-amount { font-size: 28px; font-weight: bold; }

                .t-section { padding: 0 15px 20px 15px; }
                .t-label { font-size: 14px; font-weight: 600; color: #333; margin-bottom: 8px; display: block;}

                .t-select-wrap { position: relative; margin-bottom: 20px; }
                .t-select {
                    width: 100%; padding: 14px 15px; border: 1px solid #e0e0e0; border-radius: 8px;
                    font-size: 15px; color: #333; outline: none; appearance: none; background: #fff; cursor: pointer;
                }
                .t-select:focus { border-color: #2ba1d8; }
                .t-select-arrow { position: absolute; right: 15px; top: 50%; transform: translateY(-50%); color: #888; pointer-events: none;}

                .t-sanh-bal {
                    background: #fff; padding: 15px; border-radius: 8px; border: 1px solid #eee; margin-bottom: 20px;
                    display: flex; justify-content: space-between; align-items: center;
                }

                .t-radio-group { display: flex; gap: 15px; margin-bottom: 20px; }
                .t-radio-item {
                    flex: 1; display: flex; align-items: center; justify-content: center; gap: 8px;
                    padding: 12px; background: #fff; border: 1px solid #e0e0e0; border-radius: 8px;
                    cursor: pointer; transition: 0.2s; font-size: 14px; font-weight: 500;
                }
                .t-radio-item.active { border-color: #2ba1d8; background: #f4fafe; color: #2ba1d8; }

                .t-input-wrap { position: relative; display: flex; align-items: center; margin-bottom: 5px; }
                .t-input {
                    width: 100%; padding: 14px 70px 14px 15px; border: 1px solid #e0e0e0; border-radius: 8px;
                    font-size: 16px; outline: none; transition: 0.2s; background: #fff;
                }
                .t-input:focus { border-color: #2ba1d8; }
                .t-input-max {
                    position: absolute; right: 15px; font-size: 14px; color: #2ba1d8; font-weight: 600; cursor: pointer;
                }

                .t-submit-btn {
                    width: 100%; background: #2ba1d8; color: #fff; border: none;
                    border-radius: 8px; padding: 15px 0; font-size: 16px; font-weight: bold;
                    cursor: pointer; transition: opacity 0.2s; box-shadow: 0 4px 10px rgba(43, 161, 216, 0.2);
                }
                .t-submit-btn:disabled { background: #aaa; box-shadow: none; cursor: not-allowed; }
            `}} />

            {loading && (
                <div className="loading" style={{zIndex: 99999}}>
                    <div className="loader"></div>
                </div>
            )}

            <div className="t-app-main">
                <AnimatedPage>
                    {/* ===== HEADER ===== */}
                    <div className="t-header">
                        <div className="t-header-back" onClick={handleBackClick}>
                            <KeyboardArrowLeftOutlinedIcon style={{ fontSize: 28, color: '#333' }} />
                        </div>
                        <div className="t-header-title">Chuyển tiền sảnh</div>
                        <div style={{ width: '28px' }}></div> 
                    </div>

                    {/* ===== VÍ CHÍNH ===== */}
                    <div className="t-bal-wrap">
                        <div className="t-bal-title">Số dư tài khoản</div>
                        <div className="t-bal-amount">
                            {profile?.money ? profile.money.toLocaleString("vi-VN") : "0"} ₫
                        </div>
                    </div>

                    {/* ===== FORM CHÍNH ===== */}
                    <form className="t-section" onSubmit={handleSubmit(onSubmit)}>
                        
                        {/* 1. CHỌN SẢNH */}
                        <label className="t-label">Sảnh Game</label>
                        <div className="t-select-wrap">
                            <select className="t-select" value={sanh || ""} onChange={handleChange}>
                                <option value="" disabled hidden>-- Chọn sảnh --</option>
                                <option value="4">AG</option>
                                <option value="79">BBIN</option>
                                <option value="104">CMD</option>
                                <option value="16">CQ9</option>
                                <option value="27">DG</option>
                                <option value="86">Evolution</option>
                                <option value="142">FB</option>
                                <option value="140">JILI</option>
                                <option value="121">KingMaker</option>
                                <option value="102">V8 Poker</option>
                                <option value="123">King Poker</option>
                                <option value="43">MG</option>
                                <option value="39">PP</option>
                                <option value="174">SABA</option>
                                <option value="54">SBO</option>
                                <option value="151">UG</option>
                                <option value="118">WM</option>
                                <option value="99">TF</option>
                                <option value="112">SEXY</option>
                                <option value="111">Playtech</option>
                                <option value="28">Allbet</option>
                                <option value="55">JDB</option>
                                <option value="202">WS168</option>
                                <option value="61">IMES</option>
                                <option value="132">SV388</option>
                            </select>
                            <div className="t-select-arrow">
                                <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor"><path d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z"/></svg>
                            </div>
                        </div>

                        {/* HIỂN THỊ SỐ DƯ SẢNH */}
                        {sanh && (
                            <div className="t-sanh-bal">
                                <span style={{color: '#666', fontSize: '14px'}}>Số dư trong sảnh:</span>
                                <span style={{fontWeight: 'bold', fontSize: '16px', color: '#2ba1d8'}}>
                                    {balance?.toLocaleString("vi-VN")} ₫
                                </span>
                            </div>
                        )}

                        {/* 2. CHỌN LOẠI CHUYỂN */}
                        <div className="t-label" style={{marginTop: '10px'}}>Thao tác</div>
                        <div className="t-radio-group">
                            <div className={`t-radio-item ${type === 1 ? 'active' : ''}`} onClick={() => { setType(1); setNewMoney(""); setValue("money", "");}}>
                                <div style={{width: '16px', height: '16px', borderRadius: '50%', border: '2px solid currentColor', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                                    {type === 1 && <div style={{width: '8px', height: '8px', background: 'currentColor', borderRadius: '50%'}}></div>}
                                </div>
                                Chuyển quỹ vào
                            </div>
                            <div className={`t-radio-item ${type === 2 ? 'active' : ''}`} onClick={() => { setType(2); setNewMoney(""); setValue("money", "");}}>
                                <div style={{width: '16px', height: '16px', borderRadius: '50%', border: '2px solid currentColor', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                                    {type === 2 && <div style={{width: '8px', height: '8px', background: 'currentColor', borderRadius: '50%'}}></div>}
                                </div>
                                Chuyển quỹ ra
                            </div>
                        </div>

                        {/* 3. NHẬP SỐ TIỀN */}
                        <div className="t-label">Số điểm chuyển</div>
                        <div className="t-input-wrap">
                            <input 
                                className="t-input" 
                                type="text" 
                                placeholder="Nhập số tiền"
                                value={newMoney || ""}
                                {...register("money", { required: true })}
                                onChange={(e) => {
                                    // Loại bỏ ký tự không phải số
                                    const val = e.target.value.replace(/\D/g, "");
                                    const formatted = val ? Number(val).toLocaleString("vi-VN") : "";
                                    setNewMoney(formatted);
                                    setValue("money", formatted);
                                }}
                            />
                            <div className="t-input-max" onClick={selectAll}>Tất cả</div>
                        </div>

                        {/* 4. TÍNH TOÁN QUY ĐỔI GIỮ NGUYÊN TỪ CODE CŨ */}
                        {type === 1 && newMoney && (
                            <div style={{ marginBottom: "25px", fontSize: "14px", color: "#555", textAlign: "right" }}>
                                Số tiền nhận được trong game: <b style={{ color: "#d32f2f" }}>{(Number(newMoney.replaceAll(".", "")) / 1000).toLocaleString("vi-VN")}</b>
                            </div>
                        )}
                        {type === 2 && newMoney && (
                            <div style={{ marginBottom: "25px", fontSize: "14px", color: "#555", textAlign: "right" }}>
                                Số tiền nhận vào ví chính: <b style={{ color: "#d32f2f" }}>{(Number(newMoney.replaceAll(".", "")) * 1000).toLocaleString("vi-VN")}</b>
                            </div>
                        )}
                        {!newMoney && <div style={{ marginBottom: "25px" }}></div>}

                        <button type="submit" className="t-submit-btn" disabled={load || loading}>
                            {load ? "Đang xử lý..." : "Xác nhận"}
                        </button>
                    </form>
                </AnimatedPage>
            </div>
            
            <Footer />
        </div>
    );
}

export default TransferGame;